export const LABELS_LOAD = 'LABELS_LOAD';
export const LABEL_CREATE = 'LABEL_CREATE';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DELETE = 'LABEL_DELETE';
